import routesConfig from '~/locales/routes.json';

export const supportedLanguages = routesConfig.locales;
export const locales = routesConfig.locales;
export const defaultLocale = routesConfig.defaultLocale;

export type Locale = (typeof supportedLanguages)[number];
export type Lang = Locale; // Alias for backwards compatibility

/**
 * Detects locale from a pathname string.
 * If the first segment is a known locale, returns it; otherwise returns the channel's defaultLocale.
 */
export function detectLocale(_pathname: string, _channelDefaultLocale?: string): Locale;
/**
 * Detects locale from a Request object by extracting the pathname.
 */
export function detectLocale(_request: Request, _channelDefaultLocale?: string): Locale;
/**
 * Implementation: accepts either a pathname string or a Request object.
 * @param channelDefaultLocale - Optional default locale from channel config (for hostname-based routing)
 */
export function detectLocale(input: string | Request, channelDefaultLocale?: string): Locale {
  const pathname = typeof input === 'string' ? input : new URL(input.url).pathname;
  const seg = pathname.split('/')[1];
  const effectiveDefault = (channelDefaultLocale ?? defaultLocale) as Locale;
  return locales.includes(seg) ? (seg as Locale) : effectiveDefault;
}
